import * as Yup from "yup";

const TransQuerySchema = Yup.object().shape({
  transactions: Yup.array().min(1, `Please select at least one transaction`).required(),
});

export default TransQuerySchema;
